/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiMeetingFeaturesContentFromJSON(json) {
    return StreemApiMeetingFeaturesContentFromJSONTyped(json, false);
}
export function StreemApiMeetingFeaturesContentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'maxResolution': !exists(json, 'max_resolution') ? undefined : json['max_resolution'],
    };
}
export function StreemApiMeetingFeaturesContentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'max_resolution': value.maxResolution,
    };
}
//# sourceMappingURL=StreemApiMeetingFeaturesContent.js.map